// Mobile drawer helpers: menu/cart drawer positioning under the announcement bar and the
// showMegamenuMobile / closeHoverContant submenu handlers used by onclick="" attributes in
// snippets/header-drawer.liquid. Moved out of that snippet (was inline on every page).
  // =================== Fix menu drawer position based on announcement bar ===========================
  // knownHeaderHeight: header height already measured by the ResizeObserver below. Passing it in
  // avoids re-reading offsetHeight right after the other drawer's style writes (a forced reflow
  // flagged by PageSpeed). Without it (scroll / resize / attribute changes) it is read as before.
  function updateMenuDrawerPosition(knownHeaderHeight) {
    if (window.innerWidth > 749) return; // Only for mobile
    
    const menuDrawer = document.querySelector('.menu-drawer');
    const headerComponent = document.querySelector('#header-component');
    const headerGroup = document.querySelector('#header-group');
    const announcementBar = document.querySelector('announcement-bar-component');
    
    if (!menuDrawer || !headerComponent || !headerGroup) return;
    
    // Calculate header height
    const headerHeight = knownHeaderHeight || headerComponent.offsetHeight || 60;
    
    // Check if announcement bar exists and is visible
    let announcementBarHeight = 0;
    if (announcementBar) {
      const announcementBarElement = announcementBar.closest('.announcement-bar');
      if (announcementBarElement) {
        const rect = announcementBarElement.getBoundingClientRect();
        // Check if announcement bar is visible (not scrolled out of view)
        // If top is negative, it means scrolled up, so don't count it
        if (rect.top >= 0 && rect.bottom > 0 && rect.height > 0) {
          announcementBarHeight = rect.height;
        }
      }
    }
    
    // Get scroll direction and sticky state
    const scrollDirection = headerComponent.getAttribute('data-scroll-direction') || 'none';
    const stickyState = headerComponent.getAttribute('data-sticky-state') || 'inactive';
    
    // Calculate top position
    let topPosition = headerHeight;
    
    // If announcement bar is visible and we're at top (scroll-direction="none")
    // OR if sticky state is inactive and announcement bar is visible
    if (announcementBarHeight > 0) {
      if (scrollDirection === 'none') {
        topPosition = headerHeight + announcementBarHeight;
      } else {
        // User has scrolled, announcement bar is hidden, use only header height
        topPosition = headerHeight;
      }
    } else {
      // No announcement bar or it's scrolled out of view
      topPosition = headerHeight;
    }
    
    // Set CSS custom property for dynamic positioning
    document.documentElement.style.setProperty('--menu-drawer-top', `${topPosition}px`);
    
    // Apply the position directly to menu drawer
    menuDrawer.style.setProperty('--header-drawer-top', `${topPosition}px`, 'important');
    
    // Update height
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const calculatedHeight = viewportHeight - topPosition;
    menuDrawer.style.setProperty('height', `${calculatedHeight}px`, 'important');
  }
  
  // The drawer position = header height (+ announcement bar height while it is visible at the top).
  // Without an announcement bar the result is just the header height, which doesn't change while
  // scrolling, so the scroll listener and header-attribute observer (each re-measuring layout on
  // every scroll / sticky-state change) are only attached when an announcement bar exists.
  // Header height changes are picked up by the ResizeObserver below, the address bar by 'resize'.
  const hasAnnouncementBar = !!document.querySelector('announcement-bar-component');

  // Initial position: no synchronous measuring at load (it forced a layout while the page was still
  // building). The header ResizeObserver below fires once right after the first layout and positions
  // both drawers from its measured height; without ResizeObserver, run once in the next frame.
  
  let scrollTimeout;
  if (hasAnnouncementBar) {
    // Update on scroll
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateMenuDrawerPosition, 50);
    }, { passive: true });
  }
  
  // Update on resize
  window.addEventListener('resize', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateMenuDrawerPosition, 100);
  });
  
  // Observe header component for attribute changes
  const headerComponent = document.querySelector('#header-component');
  if (headerComponent && hasAnnouncementBar) {
    const observer = new MutationObserver(() => {
      updateMenuDrawerPosition();
    });
    observer.observe(headerComponent, {
      attributes: true,
      attributeFilter: ['data-scroll-direction', 'data-sticky-state']
    });
  }

  // Header height changes (e.g. layout/font changes) update both drawers. The height comes from the
  // observer entry, so neither function has to read layout after the other has written styles.
  if (headerComponent && 'ResizeObserver' in window) {
    new ResizeObserver((entries) => {
      const entry = entries[entries.length - 1];
      const box = entry && entry.borderBoxSize && entry.borderBoxSize[0];
      const measured = box ? Math.round(box.blockSize) : 0;
      updateMenuDrawerPosition(measured);
      updateCartDrawerPosition(measured);
    }).observe(headerComponent);
  } else {
    requestAnimationFrame(() => {
      updateMenuDrawerPosition();
      updateCartDrawerPosition();
    });
  }
  
  // Observe announcement bar visibility
  const announcementBar = document.querySelector('announcement-bar-component');
  if (announcementBar) {
    const resizeObserver = new ResizeObserver(() => {
      updateMenuDrawerPosition();
      updateCartDrawerPosition();
    });
    resizeObserver.observe(announcementBar.closest('.announcement-bar') || announcementBar);
  }

  // =================== Fix cart drawer position based on announcement bar ===========================
  function updateCartDrawerPosition(knownHeaderHeight) {
    if (window.innerWidth > 749) return; // Only for mobile
    
    const cartDrawer = document.querySelector('.cart-drawer__dialog');
    const headerComponent = document.querySelector('#header-component');
    const headerGroup = document.querySelector('#header-group');
    const announcementBar = document.querySelector('announcement-bar-component');
    
    if (!cartDrawer || !headerComponent || !headerGroup) return;
    
    // Calculate header height
    const headerHeight = knownHeaderHeight || headerComponent.offsetHeight || 60;
    
    // Check if announcement bar exists and is visible
    let announcementBarHeight = 0;
    if (announcementBar) {
      const announcementBarElement = announcementBar.closest('.announcement-bar');
      if (announcementBarElement) {
        const rect = announcementBarElement.getBoundingClientRect();
        // Check if announcement bar is visible (not scrolled out of view)
        if (rect.top >= 0 && rect.bottom > 0 && rect.height > 0) {
          announcementBarHeight = rect.height;
        }
      }
    }
    
    // Get scroll direction and sticky state
    const scrollDirection = headerComponent.getAttribute('data-scroll-direction') || 'none';
    const stickyState = headerComponent.getAttribute('data-sticky-state') || 'inactive';
    
    // Calculate top position
    let topPosition = headerHeight;
    
    // If announcement bar is visible and we're at top (scroll-direction="none")
    if (announcementBarHeight > 0) {
      if (scrollDirection === 'none') {
        topPosition = headerHeight + announcementBarHeight;
      } else {
        // User has scrolled, announcement bar is hidden, use only header height
        topPosition = headerHeight;
      }
    } else {
      // No announcement bar or it's scrolled out of view
      topPosition = headerHeight;
    }
    
    // Apply the position directly to cart drawer
    cartDrawer.style.setProperty('top', `${topPosition}px`, 'important');
    
    // Update height if needed
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const calculatedHeight = viewportHeight - topPosition;
    if (window.innerWidth <= 500) {
      cartDrawer.style.setProperty('height', `${calculatedHeight}px`, 'important');
    }
  }
  
  // Cart drawer initial position: set by the header ResizeObserver above (see "Initial position").
  
  // Update cart drawer on scroll (only needed with an announcement bar, see above)
  let cartScrollTimeout;
  if (hasAnnouncementBar) {
    window.addEventListener('scroll', () => {
      clearTimeout(cartScrollTimeout);
      cartScrollTimeout = setTimeout(updateCartDrawerPosition, 50);
    }, { passive: true });
  }
  
  // Update cart drawer on resize
  window.addEventListener('resize', () => {
    clearTimeout(cartScrollTimeout);
    cartScrollTimeout = setTimeout(updateCartDrawerPosition, 100);
  });
  
  // Observe header component for cart drawer attribute changes
  const headerComponentForCart = document.querySelector('#header-component');
  if (headerComponentForCart && hasAnnouncementBar) {
    const cartObserver = new MutationObserver(() => {
      updateCartDrawerPosition();
    });
    cartObserver.observe(headerComponentForCart, {
      attributes: true,
      attributeFilter: ['data-scroll-direction', 'data-sticky-state']
    });
  }

  // =================== open menu mobile ===========================
  // Keep mobile menu open/close handlers light to protect INP.
  // Avoid smooth scrolling and unnecessary logging; just do minimal DOM work.
  function showMegamenuMobile(ele) {
    const drawer = ele.closest(".menu-drawer");
    if (!drawer) return;

    // Jump scroll to top without smooth behavior to avoid long-running animations.
    drawer.scrollTop = 0;

    const dropdown = ele.nextElementSibling;
    if (dropdown) {
      dropdown.classList.add("show-active");
      drawer.classList.add("drawer-hidden-mobile-open-menu");
    }
  }

  // =================== close menu mobile ===========================
  function closeHoverContant(ele) {
    const drawer = ele.closest(".menu-drawer");
    if (!drawer) return;

    const parentActive = ele.closest(".show-active");
    if (parentActive) {
      parentActive.classList.remove("show-active");
    }
    drawer.classList.remove("drawer-hidden-mobile-open-menu");
  }
  // =================== slide bar code mobile ===========================
